import { render, staticRenderFns } from "./PullRequest.vue?vue&type=template&id=3447a9ee&scoped=true&lang=html&"
import script from "./PullRequest.vue?vue&type=script&lang=js&"
export * from "./PullRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3447a9ee",
  null
  
)

export default component.exports